import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import ShopHeader from '../../components/customer/ShopHeader';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import api from '../../utils/api';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const { t } = useTranslation();

  // Redirect if already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/shop');
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      // Register user
      await api.post('/auth/register', {
        name: formData.name,
        email: formData.email,
        password: formData.password
      });

      // Auto login after registration
      const loginResult = await login(formData.email, formData.password);
      
      if (loginResult.success) {
        navigate('/shop');
      } else {
        setError('Registration successful! Please login.');
        navigate('/login');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--light)' }}>
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-icon">✨</div>
            <h1 className="auth-title">{t('register.title')}</h1>
            <p className="auth-subtitle">{t('register.subtitle')}</p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-error">{error}</div>}
            
            <Input
              label={t('register.fullName')}
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="გიორგი ჯანელიძე"
              required
              icon="👤"
            />

            <Input
              label={t('register.email')}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              required
              icon="✉️"
            />

            <Input
              label={t('register.password')}
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="************"
              required
              icon="🔒"
            />

            <Input
              label={t('register.confirmPassword')}
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="************"
              required
              icon="🔒"
            />

            <div className="auth-terms">
              <label className="remember-me">
                <input type="checkbox" required />
                <span>{t('register.agreeTerms')} <Link to="/terms" className="auth-link">{t('footer.terms')}</Link></span>
              </label>
            </div>

            <Button 
              type="submit" 
              variant="primary" 
              block 
              loading={loading}
            >
              {t('login.loginLink')}
            </Button>
          </form>

          <div className="auth-footer">
            <p> {t('register.haveAccount')} <Link to="/login" className="auth-link">{t('register.login')}</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;